import { all, call, put, takeLatest } from "redux-saga/effects";
import { getDetailNotifyIncomeApi } from "core/http/service/salary";
import {
  getDetailNotifyIncomeFailed,
  getDetailNotifyIncomeStart,
  getDetailNotifyIncomeSuccess,
} from "../redux/getDetailNotifyIncome";
import { ReduxStateType } from "redux-store/types";

function* getDetailNotifyIncome(
  _action: ReturnType<typeof getDetailNotifyIncomeStart>
) {
  try {
    const res = yield call(getDetailNotifyIncomeApi, _action.payload);
    yield put({
      type: getDetailNotifyIncomeSuccess.type,
      payload: { data: res?.data ?? null },
    });
  } catch (_error) {
    yield put({
      type: getDetailNotifyIncomeFailed.type,
      payload:
        _error?.type === ReduxStateType.UNAUTHORIZED ? _error.type : undefined,
    });
  }
}

function* watchGetDetailNotifyIncome() {
  yield takeLatest(getDetailNotifyIncomeStart.type, getDetailNotifyIncome);
}

export default function* getDetailNotifyIncomeSaga() {
  yield all([watchGetDetailNotifyIncome()]);
}
